import { produce } from "immer";

import { onboardingTypes as types } from "../actions";
import { LearnerOnboardingStateType } from "../../../utils";

const defaultState: LearnerOnboardingStateType = {
  onboardings: [],
  onboarding: null,
  loading: false,
  loaded: false,
};

const handleSetOnboardings = (state: any, payload: any) => {
  state.onboardings = payload.onboardings;
  state.loading = false;
  state.loaded = true;
  return state;
};

const handleSetSingleOnboarding = (state: any, payload: any) => {
  state.onboarding = payload.onboarding;
  state.loading = false;
  return state;
};

export default produce(
  (state: LearnerOnboardingStateType = defaultState, action) => {
    switch (action.type) {
      case types.SET_ONBOARDING:
        return handleSetOnboardings(state, action.payload);
      case types.GET_ONBOARDING:
        return {
          ...state,
          loading: true,
        };
      case types.GET_SINGLE_ONBOARDING:
        return {
          ...state,
          loading: true,
        };
      case types.SET_SINGLE_ONBOARDING:
        return handleSetSingleOnboarding(state, action.payload);
      default:
        return state;
    }
  }
);
